import React from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import KidexContainer from "./KidexContainer";
import devServiceCrd1 from "../../../Assets/landing-page/dev-service-1.svg";
import devServiceCrd2 from "../../../Assets/landing-page/dev-service-2.svg";
import devServiceCrd3 from "../../../Assets/landing-page/dev-service-3.svg";
import devServiceCrd4 from "../../../Assets/landing-page/dev-service-4.svg";
import devServiceCrd5 from "../../../Assets/landing-page/dev-service-5.svg";
import "swiper/swiper.min.css";

const DevelopmentServices = () => {
   return (
      <React.Fragment>
         <section className="development-services-sec outer-space">
            <div className="sec-main-heading">
               Holistic Development services <br /> offered to schools by us
            </div>
            <KidexContainer>
               <div className="development-services-crousel swiper_wrap">
                  <Swiper
                     navigation={{
                        nextEl: '.next-dev-service',
                        prevEl: '.prev-dev-service',
                     }}
                     modules={[Navigation]}
                     spaceBetween={50}
                     loop={true}
                     // slidesPerView={3.5}
                     breakpoints={{
                        320: {
                           spaceBetween: 10,
                           slidesPerView: 1,
                           loop: true
                        },
                        460: {
                           spaceBetween: 10,
                           slidesPerView: 1.2,
                           loop: true
                        },
                        480: {
                           spaceBetween: 10,
                           slidesPerView: 1.2,
                           loop: true
                        },
                        576: {
                           spaceBetween: 10,
                           slidesPerView: 2.2,
                           loop: true
                        },
                        768: {
                           spaceBetween: 24,
                           slidesPerView: 2.5,
                           loop: true
                        },
                        820: {
                           spaceBetween: 24,
                           slidesPerView: 3.5,
                           loop: true
                        },
                        960: {
                           spaceBetween: 24,
                           slidesPerView: 3.5,
                           loop: true
                        },
                     }}
                  >
                     <SwiperSlide>
                        <div className="dev-ser-card">
                           <img src={devServiceCrd1} />
                        </div>
                        <p className="dev-ser-card-text">
                           Experiential Learning Program for 21st century skills
                        </p>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="dev-ser-card">
                           <img src={devServiceCrd2} />
                        </div>
                        <p className="dev-ser-card-text">
                           Students’ Holistic Development Report Card
                        </p>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="dev-ser-card">
                           <img src={devServiceCrd3} />
                        </div>
                        <p className="dev-ser-card-text">
                           Live classes for all Beyond Academics topics
                        </p>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="dev-ser-card">
                           <img src={devServiceCrd4} />
                        </div>
                        <p className="dev-ser-card-text">
                           Beyond Academics related National Quizzes & Quiz clubs
                        </p>
                     </SwiperSlide>
                     <SwiperSlide>
                        <div className="dev-ser-card">
                           <img src={devServiceCrd5} />
                        </div>
                        <p className="dev-ser-card-text">
                           Teacher hiring &<br /> training services
                        </p>
                     </SwiperSlide>
                  </Swiper>
                  <div className="swiper-button-prev prev-dev-service"></div>
                  <div className="swiper-button-next next-dev-service"></div>
               </div>
            </KidexContainer>
         </section>
      </React.Fragment>
   );
};

export default DevelopmentServices;
